import { takeEvery, select, put } from "redux-saga/effects";
import { viewRendered, setRenderReady } from "../../reducers/pdf-slice";

function* checkPDFReady() {
  const state = yield select((state) => state);
  const { viewsReady, expectedViews } = state.pdf;

  const allReady = expectedViews.every((id) => viewsReady.includes(id));

  if (allReady && expectedViews.length > 0) {
    yield put(setRenderReady(true));
  }
}

export function* watchViewRendered() {
  yield takeEvery(viewRendered.type, checkPDFReady);
}
